import { useCallback, useRef } from 'react';
import useWorkflowUndoRedo from './useWorkflowUndoRedo';

/**
 * Shared undo/redo wiring for platform and agency workflow builders.
 */
export function useWorkflowBuilderCanvasControls({
  workflow,
  setWorkflow,
  setHasUnsavedChanges,
  enabled = true,
}) {
  const workflowRef = useRef(workflow);
  workflowRef.current = workflow;

  const undoRedo = useWorkflowUndoRedo({
    getWorkflow: () => workflowRef.current,
    applyWorkflow: (snapshot) => {
      setWorkflow(snapshot);
      setHasUnsavedChanges(true);
    },
    enabled,
  });

  const recordWorkflowChange = useCallback(
    (label) => {
      undoRedo.recordChange(label, workflowRef.current);
    },
    [undoRedo],
  );

  return {
    undoRedo,
    recordWorkflowChange,
    workflowRef,
  };
}

export default useWorkflowBuilderCanvasControls;
